import { render, staticRenderFns } from "./Terreno.vue?vue&type=template&id=97b85f02"
import script from "./Terreno.vue?vue&type=script&lang=js"
export * from "./Terreno.vue?vue&type=script&lang=js"
import style0 from "./Terreno.vue?vue&type=style&index=0&id=97b85f02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports